export function setPortalActiveMenu(selector){
    Array.from(document.getElementsByClassName('side-menu--active')).forEach(e => {
        if (e !== null && e !== undefined){ e.classList.remove('side-menu--active'); }
    });
    Array.from(document.getElementsByClassName(selector)).forEach(e => {
        if (e !== null && e !== undefined){ e.classList.add('side-menu--active'); }
    });
}

export function sanitizeParameter(parameter){
    if (parameter === null || parameter === undefined){
        parameter = '';
    }

    return parameter;
}

export function sanitizeNumericParameter(parameter){
    if (parameter === null || parameter === undefined || parseInt(parameter) < 0){
        parameter = 1;
    }

    return parameter;
}

export function sanitizeDateParameter(parameter){
    if (parameter === null || parameter === undefined){
        parameter = '';
    }
    
    parameter = Date.parse(parameter);

    if (isNaN(parameter)) { parameter = ''; }
    else{ parameter = new Date(parameter);}

    return parameter;
}

export async function getDeviceDetails() {
    // eslint-disable-next-line
    if (WURFL !== undefined){
        // eslint-disable-next-line
        var device_type = WURFL.form_factor; 
        // eslint-disable-next-line
        var device_name = WURFL.complete_device_name;
        // eslint-disable-next-line
        var device = WURFL.is_mobile ? "Mobile" : "Desktop";

        return {device_type, device_name, device};
    }
    return {};
}